module.exports = __webpack_public_path__ + "img/white.2efaa072.png";